import { findIndex, find } from 'lodash';

import { acceptanceListRoundTypeIds, acceptanceRankingValues, acceptanceValues, ballTypeIds, ballTypes, passwordForDisplay } from './eventConstants';
import { isEventPTT } from './events';

export const DoNotShowCloseRegistrationPopup = 'do-not-show-close-registration-popup';

export const formatDefaultValues = (event, clubDetails, coreUI) => {
    const defaultValues = {
        ...event,
        club: (clubDetails ? clubDetails.id : null),
    };
    if (event?.eventSettings) {
        defaultValues.eventTag = event.eventSettings.eventTagId;
    }

    if (event?.entryFee) {
        defaultValues.hasEntryFee = true;
    }

    if (event?.usapVerificationTypeId) {
        defaultValues.hasUsapVerificationTypeId = true;
    }

    if (event?.healthAndSafetyProtocols) {
        defaultValues.healthAndSafetyProtocols = [...event.healthAndSafetyProtocols];
    }

    if (event?.eventQuestions?.length > 0) {
        defaultValues.eventQuestions = [...event.eventQuestions];
    }

    if (event?.matchTimes?.length > 0) {
        defaultValues.hasEventAllottedMatchTimes = true;
        defaultValues.matchTimes = [...event.matchTimes];
    }

    if (event?.streamingLink) {
        defaultValues.displayLiveStreamLink = true;
    }

    defaultValues.isPTTEvent = isEventPTT(event);

    const { acceptanceListRankingTypes } = coreUI.types.tms.division.tournament;
    if (event?.eventDivisions?.length > 0) {
        event.eventDivisions.forEach((division, i) => {
            let ballType;
            if (division.ballType === null) {
                ballType = ballTypes.find(ballType => ballType.id === ballTypeIds.YELLOW);
                division.ballTypeValue = ballType?.value;
            } else {
                ballType = ballTypes.find(ballType => ballType.id === division.ballType);
                division.ballTypeValue = ballType?.value;
            }
            if (division?.acceptance?.buckets?.length > 0) {
                let listType = acceptanceRankingValues.UTR;
                if (division.acceptance.acceptanceRankingType) {
                    listType = find(acceptanceListRankingTypes, { id: division.acceptance.acceptanceRankingType }).value;
                }
                division.acceptance.buckets.forEach((bucket) => {
                    bucket.countSpecialExempt = bucket.countSpecialExempt?.toString() ?? null;
                });
                defaultValues.eventDivisions[i].acceptance = {
                    ...division.acceptance,
                    type: acceptanceValues.LIST,
                    list: {
                        type: listType,
                        rating: division.acceptance.acceptanceRatingType,
                        buckets: division.acceptance.buckets,
                    },
                };
                if (findIndex(defaultValues.eventDivisions[i].acceptance.list.buckets, { type: acceptanceListRoundTypeIds.QUALIFYING }) === -1) { // insert qualifying round if not present
                    defaultValues.eventDivisions[i].acceptance.list.buckets.push({
                        type: acceptanceListRoundTypeIds.QUALIFYING,
                        order: 2,
                        count: null,
                    });
                }
            } else {
                defaultValues.eventDivisions[i].acceptance = {
                    type: division.allowWaitlist ? acceptanceValues.WAIT_LIST : acceptanceValues.CAPPED_REGISTRATION,
                };
            }

            if (division.environments.length > 0) {
                defaultValues.eventDivisions[i].environments = [...division.environments];
            }
            if (division.surfaces.length > 0) {
                defaultValues.eventDivisions[i].surfaces = [...division.surfaces];
            }
            if (division.registrationStartUtc || division.registrationEndUtc) {
                defaultValues.eventDivisions[i].overrideRegDates = true;
            }
        });
    }

    if (defaultValues.passwordEnabled) {
        defaultValues.eventPassword = passwordForDisplay;
    }

    return defaultValues;
};

export const generateLocalStorageKey = (key, eventId, auth) => {
    return `${key}-${eventId}-${auth?.user?.id}`;
};
